import React from 'react';
import Ellipsis from './Ellipsis';
import PageLink from './PageLink';
import styled from 'react-emotion';

const Wrapper = styled('nav')`
  display: flex;
  margin: 0.5rem 0;
`;

const renderPages = ({ totalPages, currentPage, goToPage }) => {
  let prevIsElipsis = false;
  return Array.from({ length: totalPages }, (_, i) => i + 1).reduce(
    (acc, curr) => {
      if (curr === currentPage) {
        prevIsElipsis = false;
        return [
          ...acc,
          <PageLink page={curr} goToPage={goToPage} key={curr} isCurrent />
        ];
      } else {
        if (
          // Always print first, last, current page +- 2
          curr === 1 ||
          curr === currentPage - 1 ||
          curr === currentPage - 2 ||
          curr === currentPage + 1 ||
          curr === currentPage + 2 ||
          curr === totalPages
        ) {
          prevIsElipsis = false;
          return [
            ...acc,
            <PageLink page={curr} goToPage={goToPage} key={curr} />
          ];
        } else {
          if (prevIsElipsis) {
            return acc;
          } else {
            prevIsElipsis = true;
            return [...acc, <Ellipsis key={curr} />];
          }
        }
      }
    },
    []
  );
};

const PageLinks = props => {
  return (
    <Wrapper aria-label="Pagination Navigation">{renderPages(props)}</Wrapper>
  );
};
export default PageLinks;
